export default [
  {
    title: 'Tools',
    icon: 'ToolIcon',
    children: [
      {
        title: 'Wifi QR Generator',
        route: 'wifi-qr-generator',
      }
    ],
  },
]
